// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__11atc","bigColWidth":"Table_bigColWidth__yPYdg","biggerColWidth":"Table_biggerColWidth__23YrW","row":"Table_row__-Z4X1","col":"Table_col__2EgR4"};